import React, { FC } from 'react';
import List from 'components/document-templates/components/List';

const Screen: FC = () => (
  <List
    entityName="client-templates"
    entityEndpoint="client-templates"
  />
);

export default Screen;
